import { observable, action, computed } from 'mobx';

const LOCAL_STORAGE_KEY = '936DA01F9ABD4d9d80C702AF85C822A8';

/*eslint no-use-before-define: 0*/
class LocalStorageStore {

    @observable loading;
    
    constructor() {
        this.loading = false;   
    }
   
    @action getFullname = () => {
        var jwt = this.getToken();        
        var fullName = jwt.user.FirstName + ' ' + jwt.user.LastName;

        return fullName;
    }

    @action getExpiryTime = () => {
        var jwt = this.getToken();
        
        if (jwt !== undefined)
            return jwt.exp;
        else {
            return 0;
        }
    }

    @action saveToken = (jwt) => {        
        var slot = {
            't': jwt
        } 
        
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(slot));        
    }

    @action removeToken = () => {                
        localStorage.removeItem(LOCAL_STORAGE_KEY);        
    }
        
    @action getToken = () => {        
        var token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));        
        return this.parseJwt(token);
    }

    @computed get getTokenE () {
        var token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {t:''};  
        return token.t;
    }

    parseJwt = (token)=> {    
        
        if (token !== null && token.t.split().length >= 1) {
            var base64Url = token.t.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');            
            return JSON.parse(window.atob(base64));   
        }        
        return {user: {}, exp: 0, roles: ''}
    }
}

const localStorageStore = new LocalStorageStore();

export default localStorageStore;
export { LocalStorageStore };


// WEBPACK FOOTER //
// ./src/stores/localStorageStore.js